import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.scss']
})
export class AboutUsComponent implements OnInit {
  colAmount: number = 3;
  constructor() { }

  ngOnInit(): void {
    this.colAmount = (window.innerWidth <= 600) ? 1 : 3;
  }

  onResize(event) {
    this.colAmount = (event.target.innerWidth <= 600) ? 1 : 3;
  }
}
